export const environmentCommon = {
  production: false,
  env: "common",
  envHost: "https://common",
  googleAnalyticsId:"G-COMMON",

  oamServerPath: "/oam/server/auth_cred_submit",
  oamCertificatePath: "/SecureUtility/access/x509Login",
  oamLogoutPath: "/oam/server/logout",
  logoutSuccessPath: "/opsbpssecure/public/logoutSuccess",
  logoutEmailUpdateSuccessPath: "/opsbpssecure/public/emailUpdate/success",
  sessionTimeoutPath: "/opsbpssecure/public/sessionTimeout",
  forgotPasswordPath: "/opsbpssecure/public/forgotpassword",
  oamMfaAuthPath: "/oam/server/authentication",
  api: {
    apiContext: "/ciam/bps/",
    register: "public/register",
    resetPassword: "public/passwordreset",
    forgotPassword: "public/forgotpassword",
    getRestrictedEmailDomains: "public/checkdomain",
    getUrl: "public/getURL",
    checkAccount:"public/checkAccount", 
    setNewPassword:"public/setnewpassword", 
    getNotifications:"public/notifications",
    getUserInfo: "secure/me",
    updateUserInfo: "secure/me",
    updateEmail: "secure/emailupdate",
    changePassword: "secure/passwordchange",
    getUserRoles:"secure/myroles",
    validateEmailMFA: "secure/emailmfa",
    sendEmailMFA:"secure/emailmfa",
    checkEmail: "secure/emailvalidated",
    roleReqAuthz:"secure/rolereqauthz",
    getMyservices: "secure/myservices",
    checkBackURL: "secure/checkBackURL",
    admin: {
      getRoles: "secure/paadmin/PARoleList",
      searchUsers: "secure/paadmin/PASearchUser",
      displayUser: "secure/paadmin/PADisplayUser",
      updateRole: "secure/paadmin/PAUpdateRole",
      sendWelcomeEmail: "secure/paadmin/PASendWelcomeEmail",
      resetWINAttempts: "secure/paadmin/resetWINAttempts",
      resetPassword: "secure/paadmin/resetPassword",
      setEmailAccess: "secure/paadmin/setEmailAccess",
      sendVerificationEmail: "secure/paadmin/sendVerificationEmail"
    }
  },

  getOamServerUri() {
    return this.envHost + this.oamServerPath;
  },

  getOamCertificateUri() {
    return this.envHost + this.oamCertificatePath;
  },

  getOamLogoutUri() {
    return this.envHost + this.oamLogoutPath;
  },

  getLogoutSuccessUri() {
    return this.envHost + this.logoutSuccessPath;
  },

  getLogoutEmailUpdateSuccessUri() {
    return this.envHost + this.logoutEmailUpdateSuccessPath;
  },

  getSessionTimeoutUri() {
    return this.envHost + this.sessionTimeoutPath;
  },

  getForgotPasswordUri() {
    return this.envHost + this.forgotPasswordPath;
  },

  getOamMfaAuthUri() {
    return this.envHost + this.oamMfaAuthPath;
  }
};
